export default __webpack_public_path__ + "static/media/backdrop.d3cbb45e.svg";